import React from 'react';
import { connect } from 'react-redux';
import FeatureFlag from 'components/shared/FeatureFlag';
import Session from './Session';
import MultiSession from './MultiSession';
import SessionOverview from './MultiSession/SessionOverview';

const Sessions = ({
  sessions,
  currentSessionId,
  eventId,
  rsvpType,
  meta,
  isArchived,
}) => {
  return (
    <div className="mb-32">
      {Object.keys(sessions).length === 1 &&
        sessions.map(session => (
          <Session
            sessionCount={Object.keys(sessions).length}
            meta={meta}
            session={session}
            eventId={eventId}
            key={session.id}
            rsvpType={rsvpType}
          />
        ))}
      <FeatureFlag features="events_in_development">
        {Object.keys(sessions).length > 1 && !currentSessionId && (
          <MultiSession
            sessionCount={Object.keys(sessions).length}
            meta={meta}
            sessions={sessions}
            eventId={eventId}
            isArchived={isArchived}
            rsvpType={rsvpType}
          />
        )}
        {Object.keys(sessions).length > 1 && currentSessionId && (
          <SessionOverview
            sessionCount={Object.keys(sessions).length}
            meta={meta}
            session={sessions.find(
              session => session.id.toString() === currentSessionId.toString(),
            )}
            eventId={eventId}
            isArchived={isArchived}
          />
        )}
      </FeatureFlag>
    </div>
  );
};

const mapStateToProps = state => ({
  sessions: state.sessions,
  meta: state.meta,
  eventId: state.event.id,
  rsvpType: state.event.rsvp_type,
  isArchived: state.event.is_archived,
});

export default connect(mapStateToProps)(Sessions);
